/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateRefundReceiptDto } from '../../models/create-refund-receipt-dto';

export interface ReceiptControllerRefundByTicket$Params {
  ticketId: string;

/**
 * 치료일정 ID (해당 월의 수납만 환불하기 위함)
 */
  enrollmentScheduleId?: string;
      body: CreateRefundReceiptDto
}

export function receiptControllerRefundByTicket(http: HttpClient, rootUrl: string, params: ReceiptControllerRefundByTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, receiptControllerRefundByTicket.PATH, 'post');
  if (params) {
    rb.query('ticketId', params.ticketId, {});
    rb.query('enrollmentScheduleId', params.enrollmentScheduleId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

receiptControllerRefundByTicket.PATH = '/api/receipt/refund/ticket';
